module.exports = __webpack_public_path__ + "static/media/icons.bf5bfe6c.svg";